<template>
  <div :style="{ marginTop: marginTop, paddingTop: paddingTop }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LayoutPdf',
  props: {
    marginTop: {
      type: String,
      default: '0',
    },
    paddingTop: {
      type: String,
      default: '0',
    },
  },
}
</script>
